import React from 'react';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Button} from "./Button";

export interface BackButtonProps {
  onClick: () => void
}

export const BackButton = (props: BackButtonProps) => {
  const {onClick, ...rest} = props;
  return <Button variant="text" onClick={onClick} {...rest}><ArrowBackIcon color="primary" fontSize="small" className="j-mr-1"/> Back</Button>
}

export default BackButton;